import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Select from "react-select";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
} from "./accurateSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  createChangeHandler,
  getValueStatus,
  paramsAPI,
  paramsMasterAll,
  paramsMethod,
  paramsStatusCrash,
  setOptionsMaster,
  showErrorDialog,
} from "../../utility";
import { AccurateTable } from "./AccurateTable";
import { InputDateRange } from "../../utility/InputDateRange";
import { fetchUser, selectDataUser } from "../user/userSlice";
import { fetchParam, selectDataParam } from "../param/paramSlice";

export const AccuratePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataUser = useSelector(selectDataUser);
  const dataParam = useSelector(selectDataParam);

  // Filter
  const [type, setType] = useState("");
  const [objectId, setObjectId] = useState("");
  const [status, setStatus] = useState("");
  const [name, setName] = useState("");
  const [method, setMethod] = useState("");
  const [url, setUrl] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [optionsUser, setOptionsUser] = useState([]);
  const [optionsType, setOptionsType] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchData({ pageNo: 1, pageSize: 10 }));
      await dispatch(fetchUser({ ...paramsMasterAll, is_active: true }));
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "ERP_INTEGRATED_OBJECT_CODE",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster(dataUser, setOptionsUser, "username", "name_username");
    }
  }, [dataUser]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionsType, "param_code", "param_value");
    }
  }, [dataParam]);

  const paramsFilter = {
    username: name,
    status: status,
    object_code: type,
    start_created_at: startDate,
    end_created_at: endDate,
    object_id: objectId,
  };

  const handleChangeStatus = createChangeHandler(setStatus);
  const handleChangeType = createChangeHandler(setType);
  const handleChangeSales = createChangeHandler(setName);

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Accurate"></CardHeader>{" "}
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Sales / Admin</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsUser}
                    value={getValueStatus(name, optionsUser)}
                    placeholder="Select ..."
                    onChange={handleChangeSales}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Obejct Code</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsType}
                    value={getValueStatus(type, optionsType)}
                    placeholder="Select ..."
                    onChange={handleChangeType}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Object Id</b>
                </Form.Label>

                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={objectId}
                    onChange={(e) => setObjectId(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Status</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={paramsAPI}
                    value={getValueStatus(status, paramsAPI)}
                    placeholder="Select ..."
                    onChange={handleChangeStatus}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Created Date</b>
                </Form.Label>

                <Col sm={6}>
                  <InputDateRange
                    setEndDate={setEndDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    startDate={startDate}
                    CallApi={fetchData}
                    paramsFilter={paramsFilter}
                    paramsStart={"start_created_at"}
                    paramsEnd={"end_created_at"}
                    hidden={false}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm={3}>
                  <Button
                    className="btn btn-outline-danger"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        <AccurateTable
          data={Array.isArray(data) ? data : []}
          page={pageNo}
          sizePerPage={pageSize}
          totalSize={totalRecord}
          onTableChange={handleTableChange}
          loading={loading}
          handleSearch={handleSearch}
        />
      </CardBody>
    </Card>
  );
};
